/**
 * Scale utility functions converted from scale.js
 * Provides functions for packaging and parsing scale format data
 */

/**
 * Append scale segment to scale info
 * @param iscale_info - existing scale info string
 * @param iscale_segment - segment to append
 * @returns updated scale info string
 */
export function f_tool_scale_append(iscale_info: string, iscale_segment: string): string {
  let oinfo: string;
  
  let v_scale_0: number;
  let v_scale_cfg: string;
  let v_scale_cfg_length: number;
  
  let v_scale_info: string;
  let v_scale_segment: string;
  
  oinfo = "";

  if (iscale_info.length === 0) {
    v_scale_cfg = "";
    v_scale_info = "";
  } else {	
    v_scale_0 = Number(iscale_info.substr(0, 1)); 
    v_scale_cfg_length = Number(iscale_info.substr(1, v_scale_0)); 
    v_scale_cfg = iscale_info.substr(1 + Number(v_scale_0), v_scale_cfg_length);  
    v_scale_info = iscale_info.substr(1 + Number(v_scale_0) + Number(v_scale_cfg_length), iscale_info.length);
  }

  v_scale_segment = iscale_segment;
  v_scale_cfg = String(v_scale_cfg) + String(v_scale_segment.length) + ",";
  v_scale_info = String(v_scale_info) + String(v_scale_segment);

  // scale_end
  v_scale_cfg_length = v_scale_cfg.length; 
  v_scale_0 = String(v_scale_cfg_length).length; 	
  v_scale_info = String(v_scale_0) + String(v_scale_cfg_length) + String(v_scale_cfg) + String(v_scale_info);

  oinfo = String(oinfo) + String(v_scale_info);
  
  return oinfo;
}

/**
 * Package array of strings into scale format
 * @param list - array of strings to package
 * @returns packaged scale format string
 */
export function f_tool_scale_list(list: string[]): string {
  let oinfo: string;
  
  oinfo = "";
  for (let i = 0; i < list.length; i++) {
    oinfo = f_tool_scale_append(oinfo, list[i]); 
  }
  return oinfo;		
}


/**
 * Parse scale format and get specific segment
 * @param iscale_info - scale format string
 * @param iscale_at - position to extract (1-based)
 * @returns extracted segment string
 */
export function f_tool_scale_get(iscale_info: string, iscale_at: number): string {
  let oinfo: string;

  // scale variables
  let v_scale_0: number;
  let v_scale_cfg: string;
  let v_scale_cfg_length: number;
  
  let v_scale_info: string;
  
  // counter variables
  let v_counter: number;
  let v_ix_delimiter_A: number;
  let v_ix_delimiter_B: number;
  
  let v_scale_info_A: number;
  let v_scale_info_B: number;
  
  // Set default return value
  oinfo = '';
  
  // Validate input
  if (iscale_info.length === 0) {         
    oinfo = '';
    return oinfo;
  }

  v_scale_0 = Number(iscale_info.substr(0, 1)); 
  v_scale_cfg_length = Number(iscale_info.substr(1, v_scale_0)); 
  v_scale_cfg = iscale_info.substr(1 + Number(v_scale_0), v_scale_cfg_length); 
  
  v_counter = 0;
  v_ix_delimiter_A = 0;
  v_scale_info_A = 0;  	
  
  while (true) {
    v_ix_delimiter_B = v_scale_cfg.indexOf(',', v_ix_delimiter_A);
    v_counter = v_counter + 1;     
    if (v_counter < iscale_at && v_ix_delimiter_B !== -1) {        
      v_scale_info_A = v_scale_info_A + Number(v_scale_cfg.substr(v_ix_delimiter_A, v_ix_delimiter_B - v_ix_delimiter_A));
      v_ix_delimiter_A = v_ix_delimiter_B + 1;
    } else {
      break;
    }      	 
  }

  // Get scale_info
  if (v_ix_delimiter_B !== -1) {  	
    v_scale_info_A = 1 + v_scale_0 + v_scale_cfg_length + v_scale_info_A; 
    v_scale_info_B = Number(v_scale_cfg.substr(v_ix_delimiter_A, v_ix_delimiter_B - v_ix_delimiter_A));
    oinfo = String(iscale_info.substr(v_scale_info_A, v_scale_info_B));
  } else {
    oinfo = '';   
  }

  return oinfo;
}

// Default export
export default {
  f_tool_scale_append,
  f_tool_scale_list,
  f_tool_scale_get
};